import React from 'react';

export default function ConfirmModal({ open, title, message, confirmLabel = 'Konfirmasi', cancelLabel = 'Batal', onConfirm, onCancel, loading = false }) {
  if (!open) return null;
  return (
    <div
      className="modal-overlay"
      onClick={e => { if (e.target === e.currentTarget) onCancel(); }}
    >
      <div className="modal-box" style={{ maxWidth: 420 }}>
        <div className="modal-head">
          <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--ki-text)' }}>{title}</div>
        </div>
        <div className="modal-body">
          <p style={{ color: 'var(--ki-text-muted)', fontSize: 14, lineHeight: 1.6, marginBottom: 24 }}>{message}</p>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <button className="btn btn-ghost" onClick={onCancel} disabled={loading}>{cancelLabel}</button>
            <button className="btn btn-primary" onClick={onConfirm} disabled={loading}>
              {loading ? 'Memproses...' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
